// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"c1c7c19f","919":"82cc04ca","963":"853777b2"}[chunkId] + ".chunk.js";
};